import { graphql } from "../gql";

export const promptMutationDoc = graphql(`
  mutation prompt($input: PromptInput!) {
    prompt(input: $input) {
      ...MessageFragment
      response {
        ...PromptResponseFragment
      }
      feedback {
        ...PromptFeedbackFragment
      }
      citations {
        ...InlineCitationsFragment
      }
    }
  }
`);
